module.exports = __webpack_public_path__ + "img/ind_mech.ca778beb.png";